import type { SourceLimit, VariableConfig } from "@modules/energy-manager/types"

const SOURCE_LIMIT = 150

const VARIABLES = {
    energie_tout_tout: {
        name: "Cons. totale",
        stat: "sum",
        category: "Consommation",
        unit: "kWh",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energie_elec_tout: {
        name: "Cons. élec.",
        stat: "sum",
        category: "Consommation",
        unit: "kWh",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energie_gaz_tout: {
        name: "Conso. gaz",
        stat: "sum",
        category: "Consommation",
        unit: "kWh",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energie_chaleur_tout: {
        name: "Conso. chaleur",
        stat: "sum",
        category: "Consommation",
        unit: "kWh",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardju_tout_tout: {
        name: "Conso/DJU totale (chaud 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardjufroid18_tout_tout: {
        name: "Conso/DJU totale (froid 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardju_elec_tout: {
        name: "Conso/DJU élec. (chaud 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardjufroid18_elec_tout: {
        name: "Conso/DJU élec. (froid 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardju_gaz_tout: {
        name: "Conso/DJU gaz (chaud 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardjufroid18_gaz_tout: {
        name: "Conso/DJU gaz (froid 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardju_chaleur_tout: {
        name: "Conso/DJU chaleur (chaud 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energiepardjufroid18_chaleur_tout: {
        name: "Conso/DJU chaleur (froid 18°C)",
        stat: "mean",
        category: "Conso/DJU",
        unit: "kWh/dju",
        icon: "pi pi-angle-double-up",
        iconColor: "#B975F9",
        format: ".2f",
        ranking_order: "desc",
    },
    energieparm2_tout_tout: {
        name: "Consommation/m² totale",
        stat: "sum",
        category: "Conso/m²",
        unit: "kWh/m²",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energieparm2_elec_tout: {
        name: "Consommation/m² élec.",
        stat: "sum",
        category: "Conso/m²",
        unit: "kWh/m²",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energieparm2_gaz_tout: {
        name: "Consommation/m² gaz",
        stat: "sum",
        category: "Conso/m²",
        unit: "kWh/m²",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    energieparm2_chaleur_tout: {
        name: "Consommation/m² chaleur",
        stat: "sum",
        category: "Conso/m²",
        unit: "kWh/m²",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "desc",
    },
    cout_tout_tout: {
        name: "Coût total",
        stat: "sum",
        category: "Coût",
        unit: "€",
        icon: "pi pi-money-bill",
        iconColor: "#6586D5",
        format: ".2f",
        ranking_order: "desc",
    },
    cout_elec_tout: {
        name: "Coût élec.",
        stat: "sum",
        category: "Coût",
        unit: "€",
        icon: "pi pi-money-bill",
        iconColor: "#6586D5",
        format: ".2f",
        ranking_order: "desc",
    },
    cout_gaz_tout: {
        name: "Coût gaz",
        stat: "sum",
        category: "Coût",
        unit: "€",
        icon: "pi pi-money-bill",
        iconColor: "#6586D5",
        format: ".2f",
        ranking_order: "desc",
    },
    eqCO2_tout_tout: {
        name: "eqCO₂ total",
        stat: "sum",
        category: "eqCO₂",
        unit: "eqCO₂",
        icon: "pi pi-cloud",
        iconColor: "#35C4DC",
        format: ".2f",
        ranking_order: "desc",
    },
    eqCO2_elec_tout: {
        name: "eqCO₂ élec.",
        stat: "sum",
        category: "eqCO₂",
        unit: "eqCO₂",
        icon: "pi pi-cloud",
        iconColor: "#35C4DC",
        format: ".2f",
        ranking_order: "desc",
    },
    eqCO2_gaz_tout: {
        name: "eqCO₂ gaz",
        stat: "sum",
        category: "eqCO₂",
        unit: "eqCO₂",
        icon: "pi pi-cloud",
        iconColor: "#35C4DC",
        format: ".2f",
        ranking_order: "desc",
    },
    eqCO2_chaleur_tout: {
        name: "eqCO₂ chaleur",
        stat: "sum",
        category: "eqCO₂",
        unit: "eqCO₂",
        icon: "pi pi-cloud",
        iconColor: "#35C4DC",
        format: ".2f",
        ranking_order: "desc",
    },
    temperature_air_interieur: {
        name: "Température intérieure",
        stat: "mean",
        category: "Température",
        unit: "°C",
        icon: "pi pi-sun",
        iconColor: "#FA8E42",
        format: ".2f",
        ranking_order: "desc",
    },
    energie_elecinjection_tout: {
        name: "Injection",
        stat: "sum",
        category: "Injection",
        unit: "kWh",
        icon: "fa-light fa-plug",
        iconColor: "#EEC137",
        format: ".2f",
        ranking_order: "asc",
    },
} as Record<
    string,
    {
        name: string
        stat: "sum" | "mean"
        category: string
        unit: string
        icon: string
        iconColor: string
        format: string
        ranking_order: string
    }
>

const FREQ_AVAILABLE_BY_VARIABLES = [
    {
        variable: "energie_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energie_elec_tout",
        frequencyConfigs: ["hourly", "daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energie_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energie_chaleur_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardju_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardjufroid18_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardju_elec_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardjufroid18_elec_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardju_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardjufroid18_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardju_chaleur_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energiepardjufroid18_chaleur_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energieparm2_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energieparm2_elec_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energieparm2_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energieparm2_chaleur_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "cout_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "cout_elec_tout",
        frequencyConfigs: ["hourly", "daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "cout_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "eqCO2_tout_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "eqCO2_elec_tout",
        frequencyConfigs: ["hourly", "daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "eqCO2_gaz_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "eqCO2_chaleur_tout",
        frequencyConfigs: ["daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "temperature_air_interieur",
        frequencyConfigs: ["hourly", "daily", "weekly", "monthly", "yearly"],
    },
    {
        variable: "energie_elecinjection_tout",
        frequencyConfigs: ["hourly", "daily", "weekly", "monthly", "yearly"],
    },
] as VariableConfig[]

const PERIOD_SHORTCUT_BY_FREQUENCY = {
    hourly: [
        {
            id: "current_week",
            period: { quantity: NaN, unit: "day" },
        },
        {
            id: "last_7days",
            period: { quantity: 7, unit: "day" },
        },
        {
            id: "last_1week",
            period: { quantity: 1, unit: "week" },
        },
        {
            id: "last_2weeks",
            period: { quantity: 2, unit: "week" },
        },
        {
            id: "last_30days",
            period: { quantity: 30, unit: "day" },
        },
        {
            id: "last_1month",
            period: { quantity: 1, unit: "month" },
        },
        {
            id: "custom",
            period: { quantity: 2, unit: "day" },
        },
    ],
    daily: [
        {
            id: "current_week",
            period: { quantity: NaN, unit: "day" },
        },
        {
            id: "last_7days",
            period: { quantity: 7, unit: "day" },
        },
        {
            id: "last_1week",
            period: { quantity: 1, unit: "week" },
        },
        {
            id: "last_30days",
            period: { quantity: 30, unit: "day" },
        },
        {
            id: "last_1month",
            period: { quantity: 1, unit: "month" },
        },
        {
            id: "last_3months",
            period: { quantity: 3, unit: "month" },
        },
        {
            id: "last_6months",
            period: { quantity: 6, unit: "month" },
        },
        {
            id: "last_12months",
            period: { quantity: 12, unit: "month" },
        },
        {
            id: "custom",
            period: { quantity: 2, unit: "day" },
        },
    ],
    weekly: [
        {
            id: "last_1week",
            period: { quantity: 1, unit: "week" },
        },
        {
            id: "last_4weeks",
            period: { quantity: 4, unit: "week" },
        },
        {
            id: "last_12weeks",
            period: { quantity: 12, unit: "week" },
        },
        {
            id: "custom",
            period: { quantity: 1, unit: "week" },
        },
    ],
    monthly: [
        {
            id: "last_1month",
            period: { quantity: 1, unit: "month" },
        },
        {
            id: "last_3months",
            period: { quantity: 3, unit: "month" },
        },
        {
            id: "last_6months",
            period: { quantity: 6, unit: "month" },
        },
        {
            id: "last_12months",
            period: { quantity: 12, unit: "month" },
        },
        {
            id: "custom",
            period: { quantity: 1, unit: "month" },
        },
    ],
    // yearly: [
    //     {
    //         id: "last_1year",
    //         period: { quantity: 1, unit: "year" },
    //     },
    //     {
    //         id: "last_3years",
    //         period: { quantity: 3, unit: "year" },
    //     },
    //     // {
    //     //     id: "last_5years",
    //     //     period: { quantity: 5, unit: "year" },
    //     // },
    //     {
    //         id: "custom",
    //         period: { quantity: 1, unit: "year" },
    //     },
    // ],
} as {
    [key: string]: {
        id: string
        period: { quantity: number; unit: "day" | "week" | "month" | "year" }
    }[]
}

/*
  Les règles (repris du schéma fourni) sont les suivantes :
  
  - Pour un groupe de moins de 150 sources :
    • Les variables *communes* (toutes sauf celles commençant par "energiepardju_") disposent des fréquences :
      "hourly", "daily", "weekly", "monthly", "yearly"
    • Les variables commençant par "energiepardju_" ne supportent pas "hourly".
  
  - Pour un groupe de 151 à 500 sources :
    • Pour toutes les variables, les fréquences disponibles sont : "daily", "weekly", "monthly", "yearly"
  
  - Pour un groupe de plus de 500 sources :
    • Pour toutes les variables, seules les fréquences "monthly" et "yearly" sont autorisées.
*/

// -----------------------------
// Groupe : Moins de 150 sources
// -----------------------------
const configLessThan150: SourceLimit = {
    min: 0,
    max: 150,
    config_periods: {
        hourly: {
            max: { quantity: 1, unit: "month" },
        },
        daily: {
            max: { quantity: 1, unit: "year" },
            // Go async après 3 mois
            async: { quantity: 3, unit: "month" },
        },
        weekly: {
            min: { quantity: 1, unit: "week" },
        },
        monthly: {
            min: { quantity: 1, unit: "month" },
        },
        // yearly: {
        //     min: { quantity: 1, unit: "year" },
        // },
    },
}

// -----------------------------
// Groupe : 151 à 500 sources
// -----------------------------
const config151to500: SourceLimit = {
    min: 151,
    max: 500,
    messageLimit: true,
    config_periods: {
        hourly: {
            max: { quantity: 1, unit: "month" },
            // Go async après 1 jour
            async: { quantity: 1, unit: "day" },
        },
        daily: {
            max: { quantity: 1, unit: "year" },
            // Go async après 1 mois
            async: { quantity: 1, unit: "month" },
        },
        weekly: {
            min: { quantity: 1, unit: "week" },
            // Go async après 12 semaines
            async: { quantity: 12, unit: "week" },
        },
        monthly: {
            min: { quantity: 1, unit: "month" },
            // Go async après 3 mois
            async: { quantity: 3, unit: "month" },
        },
        // yearly: {
        //     min: { quantity: 1, unit: "year" },
        //     // Go async après 1 an
        //     async: { quantity: 1, unit: "year" },
        // },
    },
}

// -----------------------------
// Groupe : Plus de 500 sources
// -----------------------------
const configMoreThan500: SourceLimit = {
    min: 501,
    max: Infinity,
    messageLimit: true,
    config_periods: {
        hourly: {
            max: { quantity: 2, unit: "week" },
            // Go async après 1 jour
            async: { quantity: 1, unit: "day" },
            disabled_shortcut: ["last_30days", "last_1month"],
        },
        daily: {
            max: { quantity: 1, unit: "year" },
            // Go async après 1 jour
            async: { quantity: 1, unit: "day" },
        },
        weekly: {
            min: { quantity: 1, unit: "week" },
            max: { quantity: 1, unit: "year" },
            // Go async après 1 semaine
            async: { quantity: 1, unit: "week" },
        },
        monthly: {
            min: { quantity: 1, unit: "month" },
            // Go async après 1 mois
            async: { quantity: 1, unit: "month" },
        },
        // yearly: {
        //     min: { quantity: 1, unit: "year" },
        //     // Go async après 1 mois
        //     async: { quantity: 1, unit: "year" },
        // },
    },
}

// Regroupement des 3 groupes de configuration
const DISPLAY_DATA_CONFIGURATION: SourceLimit[] = [
    configLessThan150,
    config151to500,
    configMoreThan500,
]

/**
 * Format de date par défaut
 */
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD"

/**
 * Mappe un statut legacy vers TASK_STATE
 * @param status - Statut legacy (PENDING, CREATED, SUCCESS, FAILURE, ERROR, SEND, WAIT, RUN, TIMEOUT)
 * @returns Statut mappé vers TASK_STATE
 */
export function mapLegacyStatusToTaskState(status: string): string {
    const statusMap: Record<string, string> = {
        // Statuts de création/attente
        PENDING: "task-received",
        CREATED: "task-received",
        SEND: "task-received",
        WAIT: "task-received",
        // Statuts d'exécution
        RUN: "task-started",
        // Statuts de succès
        SUCCESS: "task-finished-success",
        // Statuts d'échec
        FAILURE: "task-finished-failure",
        ERROR: "task-finished-failure",
        TIMEOUT: "task-finished-failure",
    }
    return statusMap[status] || status
}

export {
    FREQ_AVAILABLE_BY_VARIABLES,
    DISPLAY_DATA_CONFIGURATION,
    PERIOD_SHORTCUT_BY_FREQUENCY,
    SOURCE_LIMIT,
    VARIABLES,
}
export {
    ALARM_THRESHOLD_CHART_COLORS,
    ALARM_THRESHOLD_VARIABLE_GROUP_ORDER,
    ALARME_ALLOWED_BUILDING,
    ALARME_ALLOWED_SOURCE,
    getAlarmThresholdVariableGroupId,
} from "./alarme"
export type { AlarmThresholdVariableGroupId } from "./alarme"
